<template>
  <div class="legal">
    <div class="legal__header">
      <div class="legal__header-eaimms">
        <LogoIconAndTextSvg />
      </div>
      <div class="legal__header-title typo-medium-text">
        {{ $t('iubenda.privacy_policy') }}
      </div>
    </div>
    <div class="legal__content">
      <Loader v-if="isLoading" />
      <div class="legal__content-nav" v-if="!isLoading">
        <div class="links-nav">
          <a
            v-for="(link, index) in navigationLinks"
            :key="index"
            :href="`#${link.href}`"
            @click="setActiveClass"
            :class="{'links-nav__link': true, 'links-nav__link--active': index === 0 }"
          >
            {{ link.label }}
          </a>
        </div>
      </div>
      <div
        class="legal__content-main"
        v-html="privacyPoliciesData"
        v-if="!isLoading"
      >
      </div>
    </div>
  </div>
  <Footer />
</template>

<script setup>
import { ref, onMounted } from 'vue';
import useAjax from '@/functions/use_ajax';
import I18n from 'i18n-js';

import LogoIconAndTextSvg from '@/images/logo-icon-and-text.svg';
import Loader from '@/components/generic/loader.vue';
import Footer from '@/components/generic/footer.vue';

const ajax = useAjax();

const navigationLinks = [
  { href: 'owner_of_the_data', label: I18n.t('iubenda.owner_and_data_controller') },
  { href: 'types_of_data', label: I18n.t('iubenda.data_collection') },
  { href: 'place_of_processing', label: I18n.t('iubenda.data_processing') },
  { href: 'rights_subjects', label: I18n.t('iubenda.user_rights') },
  { href: 'further_data_processing_info', label: I18n.t('iubenda.additional_information') },
  { href: 'definitions_and_legal_references', label: I18n.t('iubenda.definitions_and_references') },
];

const isLoading = ref(true);
const privacyPoliciesData = ref(null);

onMounted(() => {
  loadData();
});

/**
 * Load iubenda data
 */
async function loadData() {
  let { ok, data } = await ajax('/privacy_policies');

  if (ok) {
    privacyPoliciesData.value = data.privacy_policies
    isLoading.value = false;
  }
}

/**
 * adds active class to nav items
 */
function setActiveClass(e) {
  const links = document.querySelectorAll('.links-nav__link');
  links.forEach(link => link.classList.remove('links-nav__link--active'));

  e.target.classList.add('links-nav__link--active');
}
</script>
